import { CSSProperties } from 'react';
import styled from 'styled-components';

import colors from '../../assets/stylesheets/_colors.scss';
import { Flex } from './flex';

interface Props {
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  direction?: CSSProperties['flexDirection'];
  transparent?: boolean;
  childMargin?: CSSProperties['margin'];
  nonDimensional?: boolean;
}

export const Frame = styled(Flex)<Props>`
  background-color: ${({ transparent }) => (transparent ? 'transparent' : colors.white)};
  padding: ${({ nonDimensional }) => (nonDimensional ? '0' : '16px 32px')};
  margin: ${({ nonDimensional }) => (nonDimensional ? '0' : '24px')};
  border-radius: 16px;
  display: flex;
  flex-direction: ${({ direction }) => direction || 'initial'};
  align-items: ${({ align }) => align || 'initial'};
  justify-content: ${({ justify }) => justify || 'initial'};
  > * {
    margin: ${({ childMargin }) => childMargin || 'initial'};
  }
`;
